import React, { useState, useEffect } from 'react'
import { useLocation } from "react-router-dom";
import { Container, Card, Row, Col, Form, Button } from 'react-bootstrap';
import { ToastContainer, toast } from 'react-toastify';

import axios from "axios";

const AddDesignation = () => {
    const userData = sessionStorage.getItem('user');
    const userObj = userData ? JSON.parse(userData) : {};
    const [editId, setEditId] = useState(null);
    const [departments, setDepartments] = useState([]);
    const [levels, setLevels] = useState([]);
    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    const routeLocation = useLocation();
    const [form, setForm] = useState({
        designation_id: "",
        description: "",
        level_id: "",
        dept_id:""
    });


    const fetchData = async () => {
        try {
            const response = await axios.post(baseUrl + "/level/", {
                action: "READ",
                school_id: userObj.school_id
            });
            setLevels(response.data);
        } catch (error) {
            console.log("Error fetching data:", error);
        }
    };
    const departmentData = async () => {
        try {
            const response = await axios.post(baseUrl + "/department/", {
                action: "READ",
                school_id: userObj.school_id
            });
            setDepartments(response.data);
        } catch (error) {
            console.log("Error fetching data:", error);
        }
    };
    useEffect(() => {
        fetchData();
        departmentData();
    }, []);

    useEffect(() => {
        if (routeLocation.state?.designationsData) {
            const designationsData = routeLocation.state.designationsData;
            setForm(designationsData);
            setEditId(designationsData.designation_id);
        }
    }, [routeLocation]);


    const handleInputChange = (e) => {
        const { id, value } = e.target;
        setForm((prevForm) => ({
            ...prevForm,
            [id]: value
        }));
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        const formData = {
            description: form.description,
            dept_id: form.dept_id,
            level_id: form.level_id,
            is_active: form.is_active || "A",
            school_id: userObj.school_id,
            action: editId !== null ? 'UPDATE' : 'CREATE',
        };

        if (editId !== null) {
            formData.designation_id = editId;
        }

        try {
            const response = await axios.post(baseUrl + "/designation/", formData, {
                headers: {
                    "Content-Type": "application/json",
                },
            });

            if (editId !== null) {
                toast.success("Record Updated Successfully");
                setEditId(null);
            } else {
                toast.success("Record Added Successfully");
            }

            setForm({
                description: "",
                dept_id: "",
                level_id: "",
            });

        } catch (error) {
            console.log("Full error object:", error);

            if (error.response) {
                const { status, data } = error.response;
                const errorMessage = data.error || data.message || "Unexpected error occurred";

                if (status === 409 && errorMessage.includes("Record already exists")) {
                    toast.error("Record already exists.", { position: "top-right" });
                } else if (status === 500) {
                    toast.error("Error submitting data: " + errorMessage, { position: "top-right" });
                } else {
                    toast.error("Unexpected error occurred", { position: "top-right" });
                }
            } else {
                toast.error("Error submitting data: " + error.message, { position: "top-right" });
            }
        }
    };
    return (
        

           

                <div className='pageBody'>
                    <ToastContainer />
                    <Container fluid>
                        <Card>
                            <Card.Body>
                                <form onSubmit={handleSubmit}>
                                    <Row>
                                        <Col xs={12}>
                                            <h6 className='commonSectionTitle'>Designation Details</h6>
                                        </Col>

                                    </Row>
                                    <Row>

                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                            <div className='commonInput'>
                                                <Form.Group>
                                                    <Form.Label>
                                                        Designation Name <span className='requiredStar'>*</span>
                                                    </Form.Label>
                                                    <Form.Control
                                                        required
                                                        type="text"
                                                        id="description"
                                                        value={form.description}
                                                        placeholder="Enter Designation Name"
                                                        maxLength={30}
                                                        onChange={handleInputChange}
                                                        onKeyDown={(e) => {
                                                            if (e.key === ' ' && e.target.selectionStart === 0) {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                    />

                                                </Form.Group>
                                            </div>
                                        </Col>
                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                            <div className="commonInput">
                                                <Form.Group>
                                                    <Form.Label>
                                                        Department Name<span className="requiredStar">*</span>
                                                    </Form.Label>
                                                    <select
                                                        className="form-select"
                                                        required
                                                        id="dept_id"
                                                        value={form.dept_id}
                                                        onChange={handleInputChange}
                                                    >
                                                        <option value="" disabled hidden>Select Department Name</option>
                                                        {(departments || [])
                                                            .filter((department) => department.is_active === "Active")
                                                            .map((department) => (
                                                                <option key={department.dept_id} value={department.dept_id}>
                                                                    {department.dept_name}
                                                                </option>
                                                            ))}
                                                    </select>
                                                </Form.Group>
                                            </div>
                                        </Col>
                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                            <div className="commonInput">
                                                <Form.Group>
                                                    <Form.Label>
                                                        Level Name <span className="requiredStar">*</span>
                                                    </Form.Label>
                                                    <select
                                                        className="form-select"
                                                        required
                                                        id="level_id"
                                                        value={form.level_id}
                                                        onChange={handleInputChange}
                                                    >
                                                        <option value="" disabled hidden>Select Level Name</option>
                                                        {(levels || [])
                                                            .filter((level) => level.is_active === "Active")
                                                            .map((level) => (
                                                                <option key={level.level_id} value={level.level_id}>
                                                                    {level.description}
                                                                </option>
                                                            ))}
                                                    </select>
                                                </Form.Group>
                                            </div>
                                        </Col>


                                    </Row>
                                    <div className="d-flex justify-content-between mt-3">
                                        <div>
                                            <Button
                                                type="button"
                                                variant="primary"
                                                className="btn-info clearBtn"
                                                onClick={() => setForm({
                                                    level_id: "",
                                                    description: "",
                                                    is_active: "A",
                                                    dept_id: ""

                                                })}

                                            >
                                                Reset
                                            </Button>
                                        </div>
                                        <div>
                                            <Button
                                                type="button"
                                                variant="primary"
                                                className="btn-danger secondaryBtn me-2"
                                                onClick={() => window.history.back()}
                                            >
                                                Cancel
                                            </Button>
                                            <Button
                                                type="submit"
                                                variant="primary"
                                                className="btn-success primaryBtn"
                                            >
                                                Submit
                                            </Button>
                                        </div>
                                    </div>
                                </form>
                            </Card.Body>
                        </Card>
                    </Container>
                
        </div>

    );
};

export default AddDesignation;